<template>
  <!-- #region template -->
  <b-container fluid>
    <b-row>
      <template v-if="state == 1">
        <template v-for="(widget, index) in dashboard.widgets">
          <b-col class="mb-4" v-if="widget.type == 'table'" cols="12" :md="widget.cols" :key="index">
            <wTable2 :options="widget.options" @openDocument="openDocument" />
          </b-col>
        </template>
      </template>
      <template v-else-if="state == 2">
        <b-col class="mb-4">
          <b-col class="mb-4">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="font-weight-medium m-0 text-dark">Settings</h5>
              <b-button variant="primary" v-on:click="$refs['form'].submit()">Save</b-button>
            </div>
          </b-col>
          <b-col class="mb-4">
            <cForm @close="update" ref="form" type="edit" noFooter card :blueprint="dashboard.blueprint" :init="document" :documents="[]" />
          </b-col>
        </b-col>
      </template>
      <template v-else-if="state == 3">
        <dRequest :path="openedDocument._reference.path" @close="close" />
      </template>
    </b-row>
  </b-container>
  <!-- #endregion -->
</template>

<script>
// #region script
// #region import
import wTable from '@/components/widgets/wTable'
import wTable2 from '@/components/widgets/wTable2'
import wTable3 from '@/components/widgets/wTable3'
import dRequest from '@/components/documents/dRequest'
import cForm from '@/components/cForm'
import { mapActions } from 'vuex'
// #endregion

// #region export

export default {
  name: 'cDashboard',
  components: {
    wTable,
    wTable2,
    wTable3,
    cForm,
    dRequest,
  },
  props: {
    dashboard: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      state: 0,
      document: {},
      openedDocument: undefined,
    }
  },
  methods: {
    ...mapActions(['getDocument']),
    openDocument(e) {
      this.openedDocument = e
      this.state = 3
    },
    close() {
      this.openedDocument = undefined
      this.state = 1
    },
    update() {
      window.location.reload()
    },
  },
  created() {
    if (!this.dashboard.widgets) {
      this.getDocument({
        reference: this.dashboard.blueprint.collection + '/' + this.dashboard.blueprint.document,
      }).then((documentSnapshot) => {
        if (documentSnapshot.exists()) {
          this.document = documentSnapshot.data()
          this.document._reference = { path: this.dashboard.blueprint.collection + '/' + this.dashboard.blueprint.document }
        } else {
          this.document = {}
          this.dashboard.blueprint.form.tabs.forEach((tab) => {
            tab.elements.forEach((element) => {
              this.document[element.key] = element.default
            })
          })
        }
        this.state = 2
      })
    } else {
      this.state = 1
    }
  },
}
// #endregion
// #endregion
</script>
